import React from "react";
import {
  List,
  TextField,
  Datagrid,
  NumberField,
  DateField,
  TextInput,
  SelectInput,
  ReferenceInput,
  ReferenceField,
  SimpleList,
  TopToolbar,
  CreateButton,
} from "react-admin";
import { CASH_PAYMENTS, MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { formatDateBg } from "../../../server/formatting/formatDateBg";
import { CashflowExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";
import { paymentRequests } from "api/paymentApi";
import { MobileListRow } from "features/MobileListRow";

const filters = [
  <TextInput
    label="Име"
    source="firstName"
    style={{ width: 230 }}
    alwaysOn
  />,
  <TextInput
    label="Фамилия"
    source="lastName"
    style={{ width: 230 }}
    alwaysOn
  />,
  <TextInput
    label="Описание"
    source="description"
    alwaysOn
  />,
  <ReferenceInput
    source="eshopId"
    reference={paymentRequests.getEshopsSelect()}
    filter={{ activeOnly: true }}
    label="Е-магазин"
    alwaysOn
  >
    <SelectInput
      label="Е-магазин"
      emptyText="Всички"
    />
  </ReferenceInput>,
];

const ListCashPayments = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={CashflowExporter(CASH_PAYMENTS)} />
      </TopToolbar>
    );
  };

  return (
    <List
      actions={<ListActions hasCreate={true} />}
      title="Касови плащания"
      filters={filters}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => <MobileListRow fields={[{ label: "Номер", value: record.id }]} />}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Сума", value: record.amount }]} />
              <MobileListRow
                fields={[
                  { label: "Име", value: record.userInfo?.firstName },
                  { label: "Презиме", value: record.userInfo?.secondName },
                  { label: "Фамилия", value: record.userInfo?.lastName },
                ]}
              />
              <MobileListRow fields={[{ label: "Описание", value: record.description }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Е-магазин",
                    value: (
                      <ReferenceField
                        source="eshopId"
                        reference={paymentRequests.getEshopsSelect()}
                      />
                    ),
                  },
                ]}
              />
              <MobileListRow fields={[{ label: "Дата на плащане", value: formatDateBg(record.paymentTimestamp) }]} />
            </div>
          )}
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <NumberField
            source="id"
            label="Номер"
            sortable={false}
          />
          <TextField
            source="userInfo.firstName"
            label="Име"
            sortable={false}
          />
          <TextField
            source="userInfo.secondName"
            label="Презиме"
            sortable={false}
          />
          <TextField
            source="userInfo.lastName"
            label="Фамилия"
            sortable={false}
          />
          <NumberField
            source="amount"
            label="Сума"
            sortable={false}
          />
          <DateField
            source="paymentTimestamp"
            label="Дата на плащане"
            showTime
            locales="bg-BG"
            sortable={false}
          />
          <TextField
            source="description"
            label="Описание"
            sortable={false}
          />
          <ReferenceField
            source="eshopId"
            reference={paymentRequests.getEshopsSelect()}
            label="Е-магазин"
            sortable={false}
          />
        </Datagrid>
      )}
    </List>
  );
};

export default ListCashPayments;
